export enum EnaioRemarkAction {
    insert = 0,
    delete = 1,
    update = 2,
    updateText = 3,
    updateColor = 4
}
export namespace EnaioRemarkAction{
    export function getName(value: EnaioRemarkAction): string {
        switch (value) {
            case EnaioRemarkAction.insert:
                return "insert";
            case EnaioRemarkAction.delete:
                return "delete";
            case EnaioRemarkAction.update:
                return "update";
            case EnaioRemarkAction.updateText:
                return "updateText";
            case EnaioRemarkAction.updateColor:
                return "updateColor";
        }
    }
}
